<template>
  <v-tabs v-model="tab" centered>
    <v-tab v-for="item in sefarim" :key="item">{{ item }}</v-tab>
  </v-tabs>
</template>
<script>
export default {
  data() {
    return {
      sefarim: [],
      tab: 0,
    };
  },
  created() {
    this.refresh();
  },
  updated() {
    if (this.$route.params.tab !== this.sefarim[this.tab]) {
      this.$router.push("/sheets/" + this.sefarim[this.tab]);
    }
    this.$emit("tab-changed", this.sefarim[this.tab]);
  },
  methods: {
    async refresh() {
      const res = await this.$axios.get("/api/parashah");
      this.sefarim = res.data.names;
      let index = this.sefarim.indexOf(this.$route.params.tab);
      if (index === -1) {
        index = 0;
      }
      this.tab = index;
    },
  },
  watch: {
    $route() {
      let index = this.sefarim.indexOf(this.$route.params.tab);
      if (index === -1) {
        index = 0;
      }
      this.tab = index;
    },
  },
};
</script>
